import { BASE_URL } from '../config'
import qs from 'query-string'
import axios from '../../function/axiosInstance'
import extract from '../../function/extract'

export const fetchInvoices = async ({
  query_params = {},
  page = 0,
  page_size = 10
}: {
  query_params?: any
  page?: number
  page_size?: number
}): Promise<any> => {
  const endpoint = qs.stringifyUrl(
    {
      url: `${BASE_URL}/invoices`,
      query: { ...query_params, page_size, current_page: page }
    },
    { skipNull: true, skipEmptyString: true }
  )

  try {
    const response = await axios.get(endpoint)
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const fetchInvoice = async ({
  invoiceId
}: {
  invoiceId: string
}): Promise<ApiResponse> => {
  try {
    const endpoint = qs.stringifyUrl(
      {
        url: `${BASE_URL}/invoices/${invoiceId}`
      },
      { skipNull: true, skipEmptyString: true }
    )

    const response = await axios.get(endpoint)
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const addLineItemsToInvoice = async ({
  invoiceId,
  lineItems
}: {
  invoiceId: string
  lineItems: {
    amount: number
    description: string
    assignment_id?: string
    project_id?: string
  }[]
}): Promise<ApiResponse> => {
  try {
    const response = await axios.put(`/invoices/${invoiceId}`, {
      line_items: lineItems
    })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const markInvoiceAsVoid = async ({
  invoiceId
}: {
  invoiceId: string
}): Promise<ApiResponse> => {
  try {
    const response = await axios.put(`/invoices/${invoiceId}/void`)
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const markInvoiceAsSent = async ({
  invoiceId
}: {
  invoiceId: string
}): Promise<ApiResponse> => {
  try {
    const response = await axios.post(`/invoices/${invoiceId}/send`)
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const markInvoicesAsPaid = async ({
  invoiceIds
}: {
  invoiceIds: string[]
}): Promise<ApiResponse> => {
  try {
    const response = await axios.post('/invoices/paid', {
      ids: invoiceIds
    })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const markInvoicesAsDraft = async ({
  invoiceIds
}: {
  invoiceIds: string[]
}): Promise<ApiResponse> => {
  try {
    const response = await axios.post('/invoices/draft', {
      ids: invoiceIds
    })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
